import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { OnlineOfflineCollection } from './online-offline.types';

export function onlineOfflineBackend(): Backend<OnlineOfflineCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
    isSubscribable: true,
  };
}
